import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { NbRoleProvider } from '@nebular/security';
import { MemberService } from '../data';
import { Member } from '../models';
import { map } from 'rxjs/operators';


@Injectable()
export class RoleProvider implements NbRoleProvider {

  constructor(
    private userService: MemberService,
    ) {}

  getRole(): Observable<string[]> {
    return this.userService.currentUser
      .pipe(
        map((member: Member) => member.roles),
      );
  }
}
